/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(document).ready(function($) {
    'use strict';

// Product Image

var slider = $('.ss-slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite:false,
    asNavFor: '.ss-slider-nav',
  //swipe: false,
  responsive: [
        {
            breakpoint: 1139,
            settings: {
                dots: true,              	
            }
        }
    ]
});
$('.ss-slider-nav').slick({
  slidesToShow: 20,
  //rows: 2,
  infinite:false,
  //slidesToScroll: 1,
  asNavFor: '.ss-slider-for',
  //dots: false,
  //centerMode: true,
  focusOnSelect: true,
  vertical: true,
  //verticalSwiping: true,
  arrows: false,
  variableWidth: false,
});
  
  
  // On before slide change
  
slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
	
  if( $('.slick-active').hasClass('activated-zoom') ){
    
    slider.slick("slickSetOption", "swipe", false, false);
    
  } else{
    
    slider.slick("slickSetOption", "swipe", true, false);
  }
});
  
   jQuery('.ss-slider-for .slick-slide .zoom').zoom();
  
  jQuery('.xzoom').click(function(){
    jQuery('.zoom-img-wrap.slick-active').addClass('activated-zoom');
    jQuery('.product-images').addClass('show-close-zoom');
    
  });
  
  jQuery('.m-close-zoom').click(function(){
    jQuery('.zoom-img-wrap').removeClass('activated-zoom');
    jQuery('.product-images').removeClass('show-close-zoom');
    
  });


});